import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  fieldLabel: { fontWeight: 600 },
  required: { color: colors.gilead.primary1 },
  inputContainer: {
    position: 'relative',
  },
  error: {
    color: colors.gilead.primary1,
    fontSize: 14,
    marginTop: theme.spacing(0.5),
  },
  input: {
    '& .Mui-disabled fieldset': {
      border: 'none',
    },
  },
}));
